import React from 'react';
import { CellRendererProps } from '../../../DataTable.types';

export interface renderFnProps {
    row: any;
    column?: any;
}

/**
 * A generic renderer for injecting custom React components into DataTable cells
 * based on the `componentName` defined in the column config.
 *
 * This renderer looks up the appropriate component render function from
 * `ComponentRenderFnRegistry` and invokes it with contextual data such as:
 *  - current row and index
 *  - column definition
 *  - dropdown/user interaction props
 * */
export const ComponentCellRenderer: React.FC<CellRendererProps> = React.memo(
    ({ row, column, dynamicProps }) => {
        const { componentRenderFnRegistry } = dynamicProps || {};

        if (!componentRenderFnRegistry) {
            console.warn('No componentRenderFnRegistry passed via dynamicProps');
            return null;
        }

        return componentRenderFnRegistry({ row, column });
    },
    (prevProps, nextProps) =>
        prevProps.row === nextProps.row &&
        prevProps.column === nextProps.column &&
        prevProps.dynamicProps?.componentRenderFnRegistry === nextProps.dynamicProps?.componentRenderFnRegistry,
);
